export enum SERVICE_ID {
    Intrum = 21
}
